import GlobalController from "../base-controllers/GlobalController.js";
import { gettext } from "../utils/i18n.js";
/**
 * Check for features and show warning if something is missing.
 */
class FeatureCheck extends GlobalController {
    constructor() {
        super(...arguments);
        this.hasDataTransferConstructor = () => {
            try {
                new DataTransfer();
                return true;
            }
            catch (_e) {
                return false;
            }
        };
    }
    init() {
        const nav = window.navigator;
        if (!("mediaDevices" in nav) ||
            !("serviceWorker" in nav) ||
            !("CSS" in window) ||
            // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/cssgrid.js
            !window.CSS.supports("grid-template-rows", "none") ||
            !this.hasDataTransferConstructor()) {
            const el = document.querySelector("#feature-check");
            const p = document.createElement("p");
            p.append(gettext("Your browser does not support features required to use the app."));
            el.append(p);
        }
    }
}
FeatureCheck.id = "FeatureCheck";
export default FeatureCheck;
//# sourceMappingURL=FeatureCheck.js.map